import Icon, { Color, Size, Type } from 'components/Icon';
import React from 'react';

const MultipleOptionsIcon = (): React.ReactElement => (
  <Icon type={Type.multipleOptions} size={Size.medium} color={Color.dark} />
);

export default MultipleOptionsIcon;
